// extracted by mini-css-extract-plugin
export default {"zoomModal":"I1-z"};